export const stats: [string, string][] = [
  ['8', 'VOLUMI COMPLETI'],
  ['480+', 'PAGINE DI CONTENUTI'],
  ['64', 'UNITÀ DIDATTICHE PRONTE'],
  ['100%', 'PRONTO DA STAMPARE E USARE'],
]
